import type { SafetyProfileStat, SafetyProfileStatKey } from "@miter/types/contracts";

import { formatStat } from "safety/components/profile/format";
import { ProfileRow, ProfileSection } from "safety/components/profile/ProfileSection";

const STAT_LABELS: Record<SafetyProfileStatKey, string> = {
  recordable_injuries: "Recordable injuries, 12 months",
  days_away_or_restricted_cases: "Days away or restricted cases",
  days_since_recordable: "Days since a recordable",
  toolbox_talks: "Toolbox talks this week",
  corrective_actions_closed: "Corrective actions closed",
  observations: "Observations",
  near_miss_reports: "Near-miss reports",
};

type StatSectionProps = {
  title: string;
  stats: SafetyProfileStat[];
};

export const StatSection = ({ title, stats }: StatSectionProps): React.JSX.Element => (
  <ProfileSection title={title}>
    {stats.map((stat) => {
      const { value, caption } = formatStat(stat);
      return <ProfileRow key={stat.key} label={STAT_LABELS[stat.key]} value={value} caption={caption} />;
    })}
  </ProfileSection>
);
